import Vue from "vue";
import Vuex from "vuex";
import Parse from "parse";
import router from "../router";
import { GOOGLE_PLACES_AUTOCOMPLETE_URL, GOOGLE_PLACE_DETAILS_URL } from "../env";
import axios from 'axios';
import { locale } from "core-js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    alert: {
      show: false,
      color: null,
      text: null,
      timeout: 2000
    },
    loading: false,
    list: null,
    myLists: null,
  },
  mutations: {
    SET_USER (state, payload) {
      state.user = payload
    },
    SET_ALERT (state, payload) {
      state.alert = payload
    },
    SET_LOADING (state, payload) { state.loading = payload},
    SET_LIST (state, payload) { state.list = payload},
    SET_MY_LISTS (state, payload) { state.myLists = payload},
  },
  actions: {
    login ({commit, dispatch}, payload) {
      commit('SET_LOADING', true)
      Parse.User.logIn(payload.username, payload.password).then(
          user=>{
            commit('SET_USER', user)
            commit('SET_LOADING', false)
            router.push('/')
          }, 
          error=>{
            commit('SET_LOADING', false)
            dispatch('changeAlert', {show: true, text: error.message, color: 'red'})
          }
        );
    },
    signup ({commit, dispatch}, payload) {
      commit('SET_LOADING', true)
      Parse.User.signUp(payload.username, payload.password).then(
          user=>{
            commit('SET_LOADING', false)
            commit('SET_USER', user)
            router.push('/')
          }, 
          error=>{
            commit('SET_LOADING', false)
            dispatch('changeAlert', {show: true, text: error.message, color: 'red'})
          }
        );
    },
    resetPassword ({commit, dispatch}, payload) {
      commit('SET_LOADING', true)
      Parse.User.requestPasswordReset(payload.username).then(
          ()=>{
            commit('SET_LOADING', false)
          }, 
          error=>{
            commit('SET_LOADING', false)
            dispatch('changeAlert', {show: true, text: error.message, color: 'red'})
          }
        );
    },
    autologin ({commit}) {
      commit('SET_USER', Parse.User.current())
    },
    changeAlert({commit}, payload) {
      commit('SET_ALERT', payload)
    },
    searchPlacesAutocomplete({}, payload, sessionToken) {
      return new Promise((resolve, reject) => {
        var service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions({ input: payload , sessionToken: sessionToken}, (predictions, status) => {
        resolve(predictions)
      });
      })
    },
    searchPlaceDetails({}, payload) {
      var request = {
        placeId: payload.place_id,
        fields: ['name', 'url', 'formatted_phone_number', 'place_id']
      };
      return new Promise((resolve, reject) => {
        var service = new google.maps.places.PlacesService(document.getElementById('googleAttributes'));
        service.getDetails(request, (place, status)=>{
          place.objectId = payload.objectId
          place.notes = payload.notes
          place.like = payload.like
          resolve(place)
        })
      })
    },
    getList({commit, dispatch}, payload) {
      var UbtaneList = Parse.Object.extend("List");
      var query = new Parse.Query(UbtaneList)
      query.include('places')
      query.include('createdBy')
      query.get(payload).then(
        res=>{
          commit("SET_LIST", res)
        },
        error=>{
          dispatch('changeAlert', {show: true, text: error.message, color: 'red'})
        }
      )
    },
    updateList({commit, dispatch}, payload) {
      // Updates list passed as payload
      return new Promise((resolve, reject) => {
        payload.save().then(
          r=>{
            dispatch('getMyLists');
            resolve(r);
          }
        )
      })
    },
    saveList({commit, dispatch}, payload) {
      return new Promise((resolve, reject) => {
        if (payload.name) this.state.list.set('name', payload.name)
        if (payload.notes) this.state.list.set('notes', payload.notes)
        if (payload.hasOwnProperty('public')) this.state.list.set('public', payload.public)
        if (Parse.User.current()) this.state.list.set('createdBy', Parse.User.current())
        this.state.list.save().then(
          r=>{
            commit('SET_LIST', r)
            resolve(r)
          }
        )
      })
    },
    createNewList({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        var UbtaneList = Parse.Object.extend("List");
        var newList = new UbtaneList()
        var listACL = new Parse.ACL(Parse.User.current())
        listACL.setPublicReadAccess(true);
        newList.setACL(listACL);
        newList.set('createdBy', Parse.User.current())
        newList.set('public', true);
        newList.set('name', '');
        newList.set('notes', '');
        newList.save().then(
          r=>{
            router.push('/list/' + r.id)
            resolve(r)
          }
        )
      })
    },
    deleteListItem({commit, dispatch}, payload) {
      return new Promise((resolve, reject) => {
        var UbtaneList = Parse.Object.extend("List");
        var query = new Parse.Query(UbtaneList)
        query.get(payload.id).then(
          res=>{
            res.destroy().then(r=>{dispatch('getMyLists')})
          },
          error=>{
            dispatch('changeAlert', {show: true, text: error.message, color: 'red'})
          }
        )
      })
    },
    addNewPlace({commit, dispatch}, payload) {
      return new Promise((resolve, reject) => {
        var UbtanePlace = Parse.Object.extend("Place");
        var newPlace = new UbtanePlace()
        var placeACL = new Parse.ACL(Parse.User.current())
        placeACL.setPublicReadAccess(true);
        newPlace.setACL(placeACL)
        newPlace.set('place_id', payload.place_id)
        newPlace.set('createdBy', Parse.User.current())
        this.state.list.addUnique('places', newPlace)
        this.state.list.save().then(
          r=>{
            // dispatch('getList', this.state.list.id);
            // resolve()
            commit('SET_LIST', r)
            resolve(r)
          }
        )
      })
    },
    updatePlace({commit, dispatch}, payload) {
      return new Promise((resolve, reject) => {
        var UbtanePlace = Parse.Object.extend("Place");
        var place = new Parse.Query(UbtanePlace)
        place.get(payload.place.objectId).then(
          res=>{
            if (payload.hasOwnProperty('like')) res.set('like', payload.like)
            if (payload.notes) res.set('notes', payload.notes)
            res.save().then(
              r=>{
                dispatch('getList', this.state.list.id);
                resolve(r)
              }
            )
          }
        )
      })
    },
    deletePlace({commit, dispatch}, payload) {
      return new Promise((resolve, reject) => {
        var UbtanePlace = Parse.Object.extend("Place");
        var place = new Parse.Query(UbtanePlace)
        place.get(payload.objectId).then(
          res=>{
            res.destroy().then(
              r=>{
                dispatch('getList', this.state.list.id);
                resolve(r)
              }
            )
          }
        )
      })
    
    },
    getMyLists({commit, dispatch}) {
      var UbtaneLists = Parse.Object.extend("List");
      var query = new Parse.Query(UbtaneLists)
      query.include('createdBy')
      query.equalTo("createdBy", Parse.User.current()).find().then(
        res=>{
          commit("SET_MY_LISTS", res)
        },
        error=>{
          dispatch('changeAlert', {show: true, text: error.message, color: 'red'})
        }
      )
    },
    getPublicLists({commit, dispatch}) {
      var UbtaneLists = Parse.Object.extend("List");
      var query = new Parse.Query(UbtaneLists)
      query.include('createdBy')
      query.equalTo("public", true).find().then(
        res=>{
          commit("SET_MY_LISTS", res)
        },
        error=>{
          dispatch('changeAlert', {show: true, text: error.message, color: 'red'})
        }
      )
    },
  },
  modules: {}
});
